import React from 'react';
import { useRouter } from 'next/router';
import withApollo from '../lib/apollo';
import withQuery from '../lib/withQuery';
import Market from '../components/Market';
import marketQuery from '../lib/queries/products/marketQuery.graphql';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';

const MarketWithQuery = withQuery(Market);

const MarketPage = () => {
  const { query: { marketId } } = useRouter();

  return (
    <MarketWithQuery
      query={marketQuery}
      variables={{ id: Number(marketId) }}
      errorMessage="Error loading market."
    />
  );
};

MarketPage.getInitialProps = redirectRouteToDomain(
  'market',
);

export default withApollo(MarketPage);
